<template>
  <v-layout justify-center>
      
    <v-fab-transition>
      <v-btn
        v-show="showFab"
        class="mx-2"
        fab
        dark
        large
        fixed
        :bottom="true"
        :right="true"
        color="primary"
        @click="toTop()"
      >
        <v-icon dark> mdi-chevron-up </v-icon>
      </v-btn>
    </v-fab-transition>

    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <client-picker
            :isAdmin="true"
            :selectedClient="selectedClient"
            @pickClient="pickClient"
          />
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col cols="12">
          <balance-viewer
            ref="balanceViewer"
            :selectedClient="selectedClient"
            :defaultCurrency="defaultCurrency"
            :addresses="addresses"
            @togglePrint="togglePrint"
            @toggleDefaultCurrency="toggleDefaultCurrency"
            :showDefaultCurrency="showDefaultCurrency"
          />
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col cols="12">
          <ledger-data-table
            ref="ledgerDataTable"
            :selectedClient="selectedClient"
            :defaultCurrency="defaultCurrency"
            :addresses="addresses"
            :docTypes="docTypes"
            :showDefaultCurrency="showDefaultCurrency"
          />
        </v-col>
      </v-row>

    <print-dialog
      ref="printDialog"
      :docTypes="docTypes"
      :selectedClient="selectedClient"
      :printFile="printFile"
      :addresses="addresses"
      :defaultCurrency="defaultCurrency"
      @togglePrint="togglePrint"
    />

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </v-container>
  </v-layout>
</template>

<script>
import ServiceLedger from "@/services/ServiceLedger";
import ServiceClient from "@/services/ServiceClient";
import ServiceCurrency from "@/services/ServiceCurrency";
import ServiceDocTypes from "@/services/ServiceDocTypes";
import debounce from "lodash/debounce";

import axios from 'axios'

import ClientPicker from "./common/ClientPicker";
import BalanceViewer from "./common/BalanceViewer";
import LedgerDataTable from "./common/LedgerDataTable.vue";
import PrintDialog from "./common/PrintDialog.vue";

export default {
  name: "admin-ledger-List",
  components: {
    ClientPicker,
    BalanceViewer,
    LedgerDataTable,
    PrintDialog,
  },
  data() {
    return {
      selectedClient: {},
      defaultCurrency: "",
      overlay: false,
      printFile: null,
      showFab: false,
      addresses: [],
      docTypes: [],
    showDefaultCurrency: false
    };
  },
  methods: {
    handleScroll() {
      this.showFab = window.scrollY > 150;
    },
    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    togglePrint()
    {
        this.$refs.printDialog.toggle();
    },
    toggleDefaultCurrency()
    {
        this.showDefaultCurrency = !this.showDefaultCurrency;
    },
    async pickClient(client) {
      try {
        if (this.selectedClient === client) {
          return;
        }
        this.overlay = true;
        this.balanceAddressId = null;

        this.selectedClient = client;

        let items = [];
        let balance = [];
        this.addresses = [];

        let showClient = true;
        let results;

        if (this.selectedClient.id) {

        if (this.$store.state.user.level == 2) {
          results = await Promise.all([
            ServiceClient.getAddressesAdmin(client.id),
            ServiceLedger.getBalanceAdmin(client.id, this.balanceAddressId),
            ServiceLedger.getLedgerAdmin(
              1,
              this.selectedClient.id,
              null,
              null,
              null,
              null,
              null,
              null
            ),
          ]);
        }

        if (this.$store.state.user.level == 1) {
            results = await Promise.all([
            ServiceClient.getAddressesSalesman(client.id),
            ServiceLedger.getBalanceSalesman(client.id, this.balanceAddressId),
            ServiceLedger.getLedgerSalesman(
              1,
              this.selectedClient.id,
              null,
              null,
              null,
              null,
              null,
              null
            ),
          ]);
        }
          this.addresses = results[0].data;
          this.addresses.unshift({
            id: null,
            value: "Todas",
          });

          showClient = false;

          balance = results[1].data;
          items = results[2].data;
        } else {

        if (this.$store.state.user.level == 2) {
          results = await Promise.all([
            ServiceLedger.getLedgerAdmin(
              1,
              this.selectedClient.id,
              null,
              null,
              null,
              null,
              null,
              null
            ),
            ServiceLedger.getBalanceAdmin(
              this.selectedClient.id,
              this.balanceAddressId
            ),
          ]);
        }

        if (this.$store.state.user.level == 1) {
          results = await Promise.all([
            ServiceLedger.getLedgerSalesman(
              1,
              this.selectedClient.id,
              null,
              null,
              null,
              null,
              null,
              null
            ),
            ServiceLedger.getBalanceSalesman(
              this.selectedClient.id,
              this.balanceAddressId
            ),
          ]);
        }

          showClient = true;

          this.addresses.push({
            id: null,
            value: "Todas",
          });

          balance = results[1].data;
          items = results[0].data;
        }
        // this.$refs.balanceViewer.setAddresses(addresses);
        this.$refs.balanceViewer.setCurrentBalance(balance);

        this.$refs.ledgerDataTable.setValues(items, showClient);

        this.$refs.ledgerDataTable.$refs.filterDialog.cleanFilters();

        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error,
        });
      }
    },
    rowClass(item) {
      if (item.balance != 0) {
        return "rowBad";
      }
    },
  },
  async mounted() {
    this.overlay = true;

    let url = process.env.VUE_APP_API_URL + "/files/printSalesman.html";
    try {
      const results = await Promise.all([
        ServiceCurrency.get(),
        ServiceDocTypes.get(),
        axios({
    url,
    method: 'GET',
    responseType: 'text'
  })
      ]);

      this.defaultCurrency = results[0].data.value;

      this.docTypes = results[1].data;

      this.printFile = results[2].data;

      this.handleDebouncedScroll = debounce(this.handleScroll, 100);
      window.addEventListener("scroll", this.handleDebouncedScroll);
    } catch (error) {
      this.$store.dispatch("setSnackbar", {
        color: "error",
        text: error,
      });
    }

    this.overlay = false;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
};
</script>
<style>
.rowBad {
  background-color: rgba(255, 0, 0, 0.3);
}
</style>
